var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentComponent,{tag:"component",attrs:{"selection":_vm.selection,"items":_vm.items},on:{"toIndex":_vm.goToIndex,"toCreate":_vm.goToCreate,"updateItems":_vm.updateItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }